import type { SaveSmsSettings, SendSmsTestResult, SmsSettings } from '../models/sms-settings';
import { actionUrl, request } from './http';

const url = (action: string) => actionUrl('FeatureManagementHandler', action);

export const getSmsSettings = () => request<SmsSettings>(url('GetSmsSettings'), { method: 'POST' });
export const saveSmsSettings = (model: SaveSmsSettings) => request<{ Success: boolean }>(url('SaveSmsSettings'), { method: 'POST', body: model });
export const setSmsEnabled = (enabled: boolean) => request<{ Success: boolean; Enabled: boolean }>(url('SetSmsEnabled'), { method: 'POST', body: { Enabled: enabled } });
export const sendSmsTest = (mobile: string, message: string) => request<SendSmsTestResult>(url('SendSmsTest'), { method: 'POST', body: { Mobile: mobile, Message: message } });
